export default __webpack_public_path__ + "static/media/Firle.9357662f.jpg";